<template>
    <div class="c-agenda">
        <div class="c-agenda__header margin-b-16">
            <div>
                <button :disabled="loading" class="c-btn c-btn--secondary c-btn--hollow no-margin" @click.prevent="setPrevious">
                    <svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 320 512"><path fill="currentColor" d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"/></svg>
                </button>
                <button :disabled="loading" class="c-btn c-btn--small c-btn--secondary c-btn--hollow no-margin" @click.prevent="setToday">Vandaag</button>
                <button :disabled="loading" class="c-btn c-btn--secondary c-btn--hollow no-margin" @click.prevent="setNext">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" height="12" width="12"><path fill="currentColor" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
                </button>
            </div>
            <div>
                <h2 class="no-margin" v-text="title"></h2>
            </div>
            <div>
                <button :disabled="loading" class="c-btn c-btn--secondary no-margin" :class="{'c-btn--hollow' : type!='month'}" @click.prevent="setMonthView">Maand</button>
                <button :disabled="loading" class="c-btn c-btn--secondary no-margin" :class="{'c-btn--hollow' : type!='year'}" @click.prevent="setYearView">Jaar</button>
            </div>
        </div>

        <div v-if="loading">
            <c-loading-container :loading="true"></c-loading-container>
        </div>
        <div v-else>
            <div class="c-agenda__container">
                <div v-if="type==='month'">
                    <div class="c-agenda__unitcontainer_month">
                        <div v-for="date in monthDates" class="c-agenda__unit " :class="date[2]" >
                            <div class="c-agenda__day-header">
                                <div class="c-agenda__unit__day"  :class="{'c-agenda__unit__day--today' : date[2]=='currentmonth'&&date[0]==new Date().getFullYear()&&month==new Date().getMonth()&&date[1]==new Date().getDate()}">
                                    {{date[1]}}
                                </div>
                                <span class="c-agenda__add" @click="createNewRequest(date)">
                                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path d="M19 11h-6V5c0-.553-.448-1-1-1s-1 .447-1 1v6H5c-.552 0-1 .447-1 1 0 .553.448 1 1 1h6v6c0 .553.448 1 1 1s1-.447 1-1v-6h6c.552 0 1-.447 1-1 0-.553-.448-1-1-1" id="plus"></path></defs><use fill="currentColor" fill-rule="nonzero" xlink:href="#plus"></use></svg>
                                </span>
                            </div>
                            <div class="c-agenda__unit__day-bottom">
                                <div class="c-agenda__bol-group">
                                    <template v-for="bol in date[3]">
                                        <router-link class="c-agenda__bol-link" :to="{name:'request-detail', params:{id: bol.id}}">
                                            <span class="c-agenda__bol margin-r-2 margin-t-2" :class="getColorClass(bol.status)"></span>
                                            <div class="c-agenda__bol-content fs-small">
                                                <div class="fw-medium">
                                                    {{ bol.opdrachtgever_naam }}
                                                </div>
                                                <div>{{ bol.naamtolk }}</div>
                                                <div>{{ bol.kenmerk }}</div>
                                            </div>
                                        </router-link>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type==='year'">
                    <div class="c-agenda__unitcontainer_year">
                        <div v-for="date in yearDates" class="c-agenda__unit" :data-field-index="date.i" :data-year="year" :data-month="date.i">
                            <div class="c-agenda__unit__day">{{getMonth(date.i)}}</div>
                            <div class="c-agenda__unit__day-bottom">
                                <div class="c-agenda__bol-group">
                                    <template v-for="bol in date.opdrachten">
                                        <router-link class="c-agenda__bol-link" :to="{name:'request-detail', params:{id: bol.id}}">
                                            <span class="c-agenda__bol margin-r-2 margin-t-2" :class="getColorClass(bol.status)"></span>
                                            <div class="c-agenda__bol-content fs-small">
                                                <div class="fw-medium">
                                                    {{ bol.opdrachtgever_naam }}
                                                </div>
                                                <div>{{ bol.naamtolk }}</div>
                                                <div>{{ bol.kenmerk }}</div>
                                            </div>
                                        </router-link>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="c-agenda__legend margin-t-8">
                <div>
                    <div class="c-agenda__bol margin-r-2 c-agenda__bol--not-accepted"></div>
                    <span>Niet geaccepteerd</span>
                </div>
                <div>
                    <div class="c-agenda__bol margin-r-2 c-agenda__bol--not-available"></div>
                    <span>Niet beschikbaar</span>
                </div>
                <div>
                    <div class="c-agenda__bol margin-r-2 c-agenda__bol--accepted"></div>
                    <span>Geaccepteerd</span>
                </div>
                <div>
                    <div class="c-agenda__bol margin-r-2 c-agenda__bol--in_progress"></div>
                    <span>In uitvoering</span>
                </div>
                <div>
                    <div class="c-agenda__bol margin-r-2 c-agenda__bol--canceled"></div>
                    <span>Geannuleerd</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import CLoadingContainer from '@components/loader/Container';
export default {
    emits: ['create-new-request'],
    components: {
        CLoadingContainer
    },
    props: {
        endpoint: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            type: 'month',
            month: new Date().getMonth(),
            year: new Date().getFullYear(),
            title: '',
            monthDates: [],
            yearDates: [],
            lastResult: null
        }
    },
    methods: {
        createNewRequest(data){
            if (data[2] !== 'currentmonth') return;
            this.$emit('create-new-request', {month: this.month+1, year: this.year, day: data[1]})
        },

        getColorClass(status){
            switch (status) {
                case 'In uitvoering':
                    return 'c-agenda__bol--in_progress';
                case 'Gereed':
                case 'Afgerond':
                    return 'c-agenda__bol--accepted';
                case 'Afgekeurd':
                case 'Geannuleerd':
                    return 'c-agenda__bol--canceled';
                default:
                    return 'c-agenda__bol--not-accepted';
            }
        },
        load() {
            this.loading = true;

            let params = {
                page: 1,
                sort: {direction: 'desc', column: 'datum'},
                length: 1000,
                type: this.type,
                year: this.year,
                workload: true
            };

            if ( this.type === 'month' ) {
                params.month = this.month;
            }

            this.$emit('load', {});

            this.$xhr.get(this.endpoint, params).then( ({result}) => {

                let title = this.year;
                if ( this.type === 'month' ) {
                    let formatter = new Intl.DateTimeFormat('nl', { month: 'long', year: 'numeric' } );
                    title = formatter.format(new Date(this.year, this.month, 1));
                    title = title[0].toUpperCase()+title.slice(1);
                }

                this.title = title;
                this.lastResult = result;

                this.updateAgendaLabels();
                this.loading = false;

            }).catch( (e) => {

                console.warn(e);

                this.loading = false;

                this.$store.dispatch('toasts/alert', {title: 'Foutmelding', text: 'Er kan geen data geladen worden'});

            });
        },

        setPrevious() {
            if ( this.type === 'year' ) {
                this.year--;
            } else if ( this.type === 'month' ) {
                let cdate = new Date( this.year, this.month, 1 );
                cdate.setMonth( this.month - 1 );
                this.month = cdate.getMonth();
                this.year = cdate.getFullYear();
            }

            this.load();
        },

        setToday() {
            this.month = new Date().getMonth();
            this.year = new Date().getFullYear();

            this.load();
        },

        setNext() {
            if ( this.type === 'year' ) {
                this.year++;
            } else if ( this.type === 'month' ) {
                let cdate = new Date( this.year, this.month, 1 );
                cdate.setMonth( cdate.getMonth() + 1 );
                this.month = cdate.getMonth();
                this.year = cdate.getFullYear();
            }

            this.load();
        },

        setMonthView() {
            this.type = 'month';
            this.load();
        },

        setYearView() {
            this.type = 'year';
            this.load();
        },

        getMonth(i) {
            let formatter = new Intl.DateTimeFormat('nl', { month: 'long' } );
            let title = formatter.format(new Date(this.year, i - 1, 1));
            title = title[0].toUpperCase()+title.slice(1);
            return title;
        },

        updateAgendaLabels() {
            if ( this.type === 'month' ) {
                let curMonth = new Date(this.year, this.month, 1);
                let firstMonth = new Date(this.year, this.month+1, 0);
                let lastMonth = new Date(this.year, this.month, 0);
                let nextMonth = new Date(this.year, this.month+1, 1);

                let firstDayIndex = curMonth.getDay(); // 0 = sunday, 6 = saturday
                if ( firstDayIndex === 0 ) {
                    firstDayIndex = 7;
                }

                let numDaysInMonth = firstMonth.getDate();
                let numDaysLastMonth = lastMonth.getDate();

                let dates = [];

                let i = 0;
                let date = null;
                if ( firstDayIndex > 1 ) {
                    // Old month
                    for ( i = firstDayIndex; i > 1; i-- ) {
                        date = [ lastMonth.getFullYear(), (numDaysLastMonth-i)+2, "previousmonth", [] ];
                        dates.push(date);
                    }
                }

                // current month
                for ( i = 0; i < numDaysInMonth; i++ ) {
                    let opdrachten = [];

                    if ( this.lastResult !== null && this.lastResult.data ) {
                        this.lastResult.data.forEach( (elm,ind) => {
                            let dateField = this.year+"-"+(this.month+1).toString().padStart(2,0)+"-"+(i+1).toString().padStart(2,0);
                            if ( elm.begintijd && elm.begintijd.startsWith(dateField) ) {
                                opdrachten.push(elm);
                            }
                        } );
                    }

                    date = [ curMonth.getFullYear(), i+1, "currentmonth", opdrachten ];
                    dates.push(date);
                }

                // next month
                if ( dates.length < 42 ) {
                    let todo = 42-dates.length;
                    for ( i = 1; i < todo+1; i++ ) {
                        date = [ nextMonth.getFullYear(), i, "nextmonth", [] ];
                        dates.push(date);
                    }
                }

                this.monthDates = dates;
            } else if ( this.type === 'year') {
                for (let i = 0; i < 12; i++) {
                    this.yearDates[i] = {i: i+1, opdrachten: []};
                }

                if ( this.lastResult !== null && this.lastResult.data ) {
                    this.lastResult.data.forEach( (elm,ind) => {
                        let dateField = this.year+"-";
                        if ( elm.begintijd && elm.begintijd.startsWith(dateField) ) {
                            let m = parseInt(elm.begintijd.toString().substring(5,7),10);
                            this.yearDates[m-1].opdrachten.push(elm);
                        }
                    } );
                }
            }
        }

    },
    mounted() {
        this.load();
    }
}
</script>
